export default __webpack_public_path__ + "static/media/logo_footer.74285f91.png";